import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertsService } from 'src/app/alerts/alerts-custom.service';
import { AlertsvarService } from 'src/app/alerts/alertsvar.service';
import { SharedService } from 'src/app/services/shared.service';
import { TimeZoneService } from 'src/app/services/time-zone.service';

@Component({
  selector: 'app-explore-alerts-action-panel',
  templateUrl: './explore-alerts-action-panel.html',
  styleUrls: ['./explore-alerts-action-panel.scss']
})
export class ExploreAlertActionPanelComponent {
  // @Input() data:any
    @Output() actionStatus:EventEmitter<object> = new EventEmitter()
    @Output() isAcknowledge:EventEmitter<boolean> = new EventEmitter()
  
    constructor(
      public sharedservice:SharedService,
      public alertvarservice:AlertsvarService,
      private alertservice:AlertsService,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private timezoneservice : TimeZoneService,
      private ref: MatDialogRef<ExploreAlertActionPanelComponent>,
    ){
  
    }
    
    actionPanelMetadata = {
      "title":"ANALYST ACTION PANEL",
      "bulk_labels":{"label1":"BULK OPERATIONS","label2":"CHECKED ALERT GROUPS"},
      "status_info":"Current Status",
      "action_headers":{"action":"NEXT STATUS ACTION","priority":"UPDATE PRIORITY (OPTIONAL)","reassign":"REASSIGN ANALYST","comment":"COMMENT","optional":"(OPTIONAL)","mandatory":"(MANDATORY)"},
      "action_buttons":{"cancel":"Cancel","save":"Save Action","acknowledge":"Acknowledge","clear":"Clear"},
      "action_placeholders":{"action":"Select Action","comment":"Select Comment (Optional)","priority":"Select Priority (Optional)","reassign":"Select Analyst"}
    }
  
    current_status = 0;
    leastStatus = 0;
    checkd_alerts_count = 0;
  
    action_panel = new FormGroup({
      action: new FormControl('',[Validators.required]),
      priority: new FormControl(),
      reassign: new FormControl(),
      reason: new FormControl()
    })
  
    current_action:any = {}

    selectedActionStatusText: string = ""
    selectedActionStateText: string = ''
    selectedReasonText: string = ''
    alertActionMetadata: any;
    alert_state: any;
    alert_status: any;
  
    
  
    ngOnInit(){
// console.log("=---->",this.data)
      // this.calculateSelectedCount()
      // this.checkd_alerts_count = this.data.alert_info.dedup.length
      // this.getLeasStatus()

      this.alertActionMetadata = this.sharedservice.metaData.alert.factsheetMeta.alertUpdateAction

      this.selectedActionStatusText = this.alertActionMetadata.defaultActionStatus
      this.selectedActionStateText = this.alertActionMetadata.defaultActionState
      this.alert_status = this.alertActionMetadata.defaultActionStatusValue
      this.alert_state = this.alertActionMetadata.defaultActionStateValue

      // this.buildReqObj()
      
    }

    ngAfterViewInit(){
      this.action.valueChanges.subscribe((actionval)=>{
        this.resetActionPanel()
        this.getActions(actionval)
      })
    }
    dataChange(){
// console.log(this.data)
    }

    buildReqObj(){

      const selectedAlert = [];
      const excludeAlert = [];

      if (!this.alertvarservice.SelectAllAlerts) {

        Object.keys(this.alertvarservice.eventWorkFlowInfo.selectedAlerts).map((batch: any) => {
          Object.keys(this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch]).map((alertkey: any) => {
            selectedAlert.push(this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch][alertkey])
          })
        })

      }
      else if (this.alertvarservice.SelectAllAlerts) {
        Object.keys(this.alertvarservice.eventWorkFlowInfo.selectedAlerts).map((batch: any) => {
          Object.keys(this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch]).map((alertkey: any) => {
            if (!this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch][alertkey]["selected"])
              excludeAlert.push(this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch][alertkey])
          })
        })
      }

      const assignReqObj = {
        platform: this.alertvarservice.alertscollapsedata.selectedalert.platform,
        alertId: this.alertvarservice.alertscollapsedata.selectedalert.alertId,
        selectedAlert: selectedAlert,
        exemptedAlert: excludeAlert,
        ref_no: this.alertvarservice.chart_ref_no,
        bulk_action: this.alertvarservice.SelectAllAlerts,
        template: this.alertvarservice.SelectAllAlerts ? { ...this.alertvarservice.template_structure } : {},
        selectednode: this.alertvarservice.nodeinfo.id,
        timerange: [this.timezoneservice.toUtcTimeZonefromUser(this.alertvarservice.advanced_filter_values.start_time).format("YYYY-MM-DD HH:mm:ss"), this.timezoneservice.toUtcTimeZonefromUser(this.alertvarservice.advanced_filter_values.end_time).format("YYYY-MM-DD HH:mm:ss")],
        status: this.alertvarservice.alertstatus.value,
        action:this.action.value,
        reason:this.reason.value,
        priority:this.priority.value,
        reassign:this.reassign.value,
        assigned_user:[this.sharedservice.getCurrentUserId()]
      }

     return assignReqObj

    }
  
    resetActionPanel(){
      this.priority.reset()
      this.reassign.reset()
      this.reason.reset()
    }
  
    validateReassign(){
      if(!this.isEmptyObject(this.current_action)  && this.current_action.reassign){
        this.reassign.addValidators(Validators.required)
      } else {
        this.reassign.removeValidators(Validators.required)
      }
      this.reassign.updateValueAndValidity();
    }
    cancelAction(){
      this.actionStatus.emit({"event":"cancel"});
      this.ref.close()
    }
  
    async saveAction(){
      // console.log("action value==",this.action_panel.value)
      // if(this.action_panel.valid){
      //   let updateObj = {...this.data.alert_info,...this.action_panel.value}
      //   this.actionStatus.emit({"event":"save","request":updateObj})
      // }

      let postObj = this.buildReqObj()

// console.log(postObj)

      await this.alertservice.exploreActionPost.postrequest(postObj).then(val=>{
// console.log(val)
        if(val["status"]){
          this.alertvarservice.clearAllPageClick()
          this.alertvarservice.$alertStatusUpdated.next(true);
          this.alertvarservice.actionUpdateToasterMsg(this.calculateSelectedCount(),val.updated_rows,1,false)
        }else{
          this.alertvarservice.createtoastmsg({
            "type":"error", 
            "text":this.alertvarservice.toaster_message_alerts.error.update_action
          })
        }
     
        
      }).catch(err=>{
// console.log(err)

      })
      this.ref.close()
    }
  
    get action() {
      return this.action_panel.get('action') as FormControl
    }
  
    get priority() {
      return this.action_panel.get('priority') as FormControl
    }
  
    get reassign(){
      return this.action_panel.get('reassign') as FormControl
    }
  
    get reason (){
      return this.action_panel.get('reason') as FormControl
    }
  
    isEmptyObject(obj: any): boolean {
      return !obj || Object.keys(obj).length === 0;
    }
  
  
    getActions(current_status:string){
      this.current_action = this.sharedservice.actions.actions[current_status]
      this.validateReassign()
      this.validateComment()
// console.log(this.current_action)
    }
  
    getReasons(action){
      if(action == 3){
        return [{"disp":"Select Comment (Optional)","value":""},...this.sharedservice.getreason(action)]
      }else{
        return this.sharedservice.getreason(action)
      }
      
    }

    getLeasStatus(){
      this.leastStatus = this.sharedservice.getLeastActionStatus(this.data.alert_info.dedup)
    }

    isCommentOptionalOrMandatory(){
      return this.current_action["comment"] ? this.actionPanelMetadata.action_headers.mandatory:this.actionPanelMetadata.action_headers.optional
    }

    validateComment(){
      if(this.current_action["comment"]){
        this.reason.addValidators(Validators.required);
      } else {
        this.reason.removeValidators(Validators.required);
      }
      this.reason.updateValueAndValidity();
    }

    // calculateSelectedCount(){
    //   let count:number
    //   if(this.data.alert_info.hasOwnProperty('selectedAlert')) {
    //     this.checkd_alerts_count = this.data.alert_info['selectedAlert'].length || this.data.totalCount
    //     count = this.data.alert_info['selectedAlert'].length || this.data.totalCount - this.data.alert_info['exemptedAlert'].length
    //   } else {
    //     this.checkd_alerts_count =  this.data.alert_info.dedup.length
    //     count =this.data.totalCount - this.data.alert_info['exemptedGroups'].length
    //   }
    //   return count
    // }

    calculateSelectedCount(){
      return this.data["totalCount"]
    }

    getApplicableActions(){
      let arr = []

      if(this.sharedservice.getCurrentUserId() == this.alertvarservice.alertAnalystFilter.value){
        arr = this.sharedservice.getActions()
      }
      else{
        this.sharedservice.getActions().forEach(val=>{
          if(val.value == 3){
            arr.push(val)
          }
        })
      }
       return arr
    }
}
